import React, { useState } from "react";
import {
  Box,
  TextField,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import { Delete, AddCircleOutline } from "@mui/icons-material";

const StringListEditor = ({ label, items, onChange }) => {
  const [draft, setDraft] = useState("");

  const addItem = () => {
    if (!draft.trim()) return;
    onChange([...items, draft.trim()]);
    setDraft("");
  };

  const deleteItem = (index) => {
    onChange(items.filter((_, i) => i !== index));
  };

  return (
    <Box sx={{ mb: "1rem" }}>
      <Typography variant="subtitle2" sx={{ mb: "0.25rem" }}>
        {label}
      </Typography>
      <List dense sx={{ py: 0 }}>
        {items.map((item, index) => (
          <ListItem
            key={`${label}-${index}`}
            disablePadding
            secondaryAction={
              <IconButton edge="end" aria-label="delete" onClick={() => deleteItem(index)}>
                <Delete fontSize="small" />
              </IconButton>
            }
          >
            <ListItemText primary={item} />
          </ListItem>
        ))}
      </List>
      <Box sx={{ display: "flex", alignItems: "center", gap: "0.5rem", mt: "0.25rem" }}>
        <TextField
          size="small"
          fullWidth
          placeholder={`Add to ${label}`}
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              addItem();
            }
          }}
        />
        <IconButton color="primary" onClick={addItem} aria-label="add">
          <AddCircleOutline />
        </IconButton>
      </Box>
    </Box>
  );
};

export default StringListEditor;
